// @ts-strict-ignore
import styled from 'styled-components';
import { useSelector } from 'src/store/store';
import SectionContent from 'src/modules/programs/components/sectionContent';
import NextPreviousLinks from 'src/modules/programs/components/nextPreviousLinks';
import { titleLarge, titleMedium } from 'styles-js/mixins/typography';

export default function ModuleContent() {
  const { currentModule, modules } = useSelector(({ pages }) => pages.programs);
  const sectionsSummary = modules.find(module => module.code === currentModule?.currentCode)?.sections;

  return (
    <>
      <Title>{currentModule?.name}</Title>
      {currentModule?.sections?.map((section) => (
        <SectionContent
          isCompleted={sectionsSummary?.find(s => s.programSectionId === section.programSectionId)?.isCompleted}
          key={section.programSectionId}
          moduleCode={currentModule?.currentCode}
          section={section}
        />
      ))}
      <NextPreviousLinks />
    </>
  );
}

const Title = styled.h2`
  ${titleLarge};

  @media (${props => props.theme.underScreenSmall}) {
    ${titleMedium};
  }
`;
